import { useContext } from "react";
import { ToastContext } from "../../../../hooks/context";
import { WarningDialog } from "../../../common";
import { usePauseSmsCampaigns } from "../../../../hooks/api/mutations/useMarketing";

export const CancelSmsCampaign = ({
  selectItem = {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { mutate: cancelCampaign, isLoading: isDeletingCampaign } =
    usePauseSmsCampaigns();

  const handleCancelCampaign = () => {
    cancelCampaign(
      { id: selectItem?.id },
      {
        onSuccess: () => {
          triggerToast("Campaign paused successfully", "success");
          closeModal();
        },
      },
    );
  };

  return (
    <WarningDialog
      closeModal={() => closeModal()}
      handler={() => handleCancelCampaign()}
      isLoading={isDeletingCampaign}
    >
      <p>
        Campaign Name: <span className="dark--text">{selectItem?.title}</span>
      </p>
      <p>
        No. of Audience:{" "}
        <span className="dark--text">
          {selectItem?.recipient_count_estimate}
        </span>
      </p>
    </WarningDialog>
  );
};
